import OrderHistory from "../../components/features/order-history/OrderHistory";

const OrderHistoryPage = () => {
  return <OrderHistory />;
};

export default OrderHistoryPage;
